var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',{staticClass:"ht-form-item",class:_vm.formItemClass,attrs:{"label":_vm.label,"label-width":_vm.labelWidth}},[_vm._t("default"),_vm._t("label",null,{"slot":"label"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }